import axios from 'axios'
import { getApiErrorMessage } from '../../../../../../../_metronic/helpers/AlertHelper'
import { TFunction } from '../../../../../../../_metronic/i18n/Metronici18n'

export type OperacaoExameImagem = 'solicitar' | 'cancelar'

export type AcaoAposErro = 'recarregarDispositivos' | 'recarregarLista' | 'nenhuma'

export type ErroExameImagem = {
  mensagem: string
  detalhe?: string
  acao: AcaoAposErro
}

export const traduzirErroExameImagem = (
  error: unknown,
  operacao: OperacaoExameImagem,
  t: TFunction
): ErroExameImagem => {
  const status = axios.isAxiosError(error) ? error.response?.status : undefined
  const detalhe = getApiErrorMessage(error) || undefined

  if (status === 400) {
    return {
      mensagem: t('exames_imagem.erro.dispositivo_indisponivel'),
      detalhe,
      acao: 'recarregarDispositivos',
    }
  }
  if (status === 409) {
    return {
      mensagem: t(
        operacao === 'solicitar'
          ? 'exames_imagem.erro.pedido_concorrente'
          : 'exames_imagem.erro.nao_aguardando'
      ),
      detalhe,
      acao: 'recarregarLista',
    }
  }
  if (status === 422) {
    return { mensagem: t('exames_imagem.erro.invalido'), detalhe, acao: 'nenhuma' }
  }
  return { mensagem: t('exames_imagem.erro.generico'), detalhe, acao: 'nenhuma' }
}
